import styled from 'styled-components';

export const Divider = styled.div`
  width: 5px;
`;
